import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { AddAssigmentToFlightRQ, AssigmentService, BillService, DeleteBillBatchRQ, DeleteBillRQ, FlightListModel, ListOpenBillByAgencyRQ } from 'app/open-api';
import { BillModel } from 'app/open-api/model/billModel';
import { AssignBillFlightModalComponent } from 'app/shared/components/assign-bill-flight-modal/assign-bill-flight-modal.component';
import { BillLocalModel } from 'app/shared/models/bill.model';
import { DownloadPdfRQ } from 'app/open-api/model/downloadPdfRQ';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-bill',
  templateUrl: './bill.component.html',
  styleUrls: ['./bill.component.scss']
})
export class BillComponent implements OnInit {

  public basicSelectedOption: number = 5;
  public bills: BillLocalModel[] = [];
  public allBills: BillLocalModel[] = [];
  selectedBills: BillLocalModel[] = [];
  selectedBill: BillLocalModel;
  public ColumnMode = ColumnMode;
  selected = [];
  public SelectionType = SelectionType;
  urlApi = environment.apiUrl;

  constructor(
    private billService: BillService,
    private assigmentService: AssigmentService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.FetchModels();
  }

  FetchModels() {
    this.spinner.show();
    const param: ListOpenBillByAgencyRQ = {
      agencyId: null
    };
    this.billService.apiBillGetOpenBillByAgencyPost(param).subscribe(response => {
      this.bills = this.ModelParse(response.list);
      this.allBills = this.ModelParse(response.list);
      this.spinner.hide();
    }, error => {
      console.warn(error);
      this.spinner.hide();
    });
  }

  onSelect({ selected }) {    
    this.selectedBills = selected as BillLocalModel[];
    this.selectedBill = this.selectedBills[this.selectedBills.length - 1];    
  }

  onCheckboxChangeFn(event: any, code: string) {
    console.log("event", event);
    console.log("code", code);
  }

  ModelParse(array: BillModel[]): BillLocalModel[] {
    return array.map(({ customerModel, senderModel, ...rest }) => ({
      ...rest,
      customerModel: JSON.parse(customerModel || ''),
      senderModel: JSON.parse(senderModel || ''),
    }));
  }

  FilterUpdate(event) {
    if (event && event !== '') {
      this.bills = this.allBills.filter(x => x.code?.toLowerCase().indexOf(event.toLowerCase()) > -1);
    } else {
      this.bills = this.allBills;
    }
  }

  DownloadPdf(billId: number){
    this.spinner.show();
    const param: DownloadPdfRQ = {
      billId: billId
    }

    this.billService.apiDownloadPdfPost(param).subscribe(response => {
      //console.log();
      const fileURL = URL.createObjectURL(response);
      window.open(fileURL, '_blank');

      Swal.fire({
        title: `El pdf se descargó satisfactoriamente.`,
        icon: 'success',
        showConfirmButton: false,
        timer: 5000,
        position: 'top'
      });

      this.spinner.hide();
    }, error => {
      //console.warn(error);
      Swal.fire({
        title: 'Error! ' + error.error,
        icon: 'error',
        showConfirmButton: false,
        timer: 5000,
        position: 'top'
      });
      this.spinner.hide();
    });   
  
  }

  totalPounds(){    
    if(this.bills.length > 0){
      let sum = this.bills.reduce((accumulator, item) => {
        return accumulator + Number(Number(item.pounds).toFixed(2));
      },0);   
      return sum; 
    }
    return 0;    
  }

  totalPaid(){
    let sum = this.bills.reduce((accumulator, item) => {
      return accumulator + Number(item.total.toFixed(2));
    },0);   
    return sum; 
  }

  OpenAssignToFlight(billId: number) {
    const refModal = this.modalService.open(AssignBillFlightModalComponent, {
      windowClass: 'modal',
      size: 'sm'
    });

    refModal.result.then((result: FlightListModel) => {
      if (result?.id) {
        this.spinner.show();
        const param: AddAssigmentToFlightRQ = {
          flightId: result.id,
          billsId: [billId]
        };
        this.assigmentService.apiAssigmentAddToFlightPost(param).subscribe(response => {
          this.FetchModels();
        });
      }
    }).catch(error => {
      this.spinner.hide();
    });
  }

  Delete(billId: number) {
    const swal = Swal.fire({
      title: '¿Está seguro que desea eliminar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-primary'
      }
    }).then(result => {
      if (result.isConfirmed) {
        this.spinner.show();
        const param: DeleteBillRQ = {
          id: billId
        };
        this.billService.apiBillDeletePost(param).subscribe(response => {
          this.FetchModels();
        }, error => {
          Swal.fire({
            title: 'Error!. ' + error,
            icon: 'error',
            showConfirmButton: false,
            timer: 2000,
            position: 'top-end'
          });
          this.spinner.hide();
        });
      }
    });
  }

  BatchDelete() {
    const swal = Swal.fire({
      title: '¿Está seguro que desea eliminar las facturas seleccionadas?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-primary'
      }
    }).then(result => {
      if (result.isConfirmed) {
        this.spinner.show();

        const param: DeleteBillBatchRQ = {
          ids: this.selectedBills.map((x) => x.id),
        };

        this.billService.apiBillBatchDeletePost(param).subscribe(response => {
          this.FetchModels();
          this.selectedBills = [];
        }, error => {
          Swal.fire({
            title: 'Error!. ' + error,
            icon: 'error',
            showConfirmButton: false,
            timer: 2000,
            position: 'top-end'
          });
          this.spinner.hide();
        });
      }
    });
  }

  GetURLById(id: number) {
    const bill = this.bills.find(b => b.id === id);
    return this.urlApi + '/Bills/' + bill.file;
  }

  GetCodeById(id: number) {
    const bill = this.bills.find(b => b.id === id);
    return bill.code;
  }

  GetServiceCodeById(id: number) {
    const bill = this.bills.find(b => b.id === id);
    return bill.serviceCode;
  }

  compareByCode(a, b): number {
    var code1 = a['code'];
    var code2 = b['code'];
 
    if (code1 > code2) {
         return 1;
    }else if (code1 < code2) {
         return -1;
    }else {
         return 0;
    }
  }
}
